
import React, { useState, useEffect } from "react";
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";


import { Link } from "react-router-dom";
import AdvanceService from "../HRService/AdvanceServices";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

function AdvanceList(props) {
  const [MyDatalist, setMyDatalist] = useState([]);
  const [searchResults, setSearchResults] = React.useState([]);
  const[draw,setDraw]=useState(0);
  const navigate = useNavigate();
 
  const handleNavigationForm = () => {
    navigate("/advance-form"); // Replace with the actual path
  };
  async function fetchPosts() {
    try {
      const fetchedPosts = await AdvanceService.getList();
      console.log("Fetched Posts:", fetchedPosts); // Debugging line
      setMyDatalist(fetchedPosts);
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  }
 
  const handleDelete =async(id)=>{
    try{
      if(window.confirm("Do you really want to delete this AdvanceList?")){
        await AdvanceService.delete(id);
        console.log('Deleted Successfully');
        setDraw((prevDraw) => prevDraw + 1); // Increment 'draw' to trigger a refresh
      }
      else {
        // User clicked Cancel or closed the dialog, do nothing or handle accordingly
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      // Handle the error or notify the user about the error
    }
    }
  

    useEffect(() => {
      fetchPosts();
    }, [props, draw]);

  return (
    <React.Fragment>
       <div className="page-content">
      <BreadCrumb title="Advance Records List" pageTitle="Advance Records" />
        <Container fluid>
        <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <h4 className="card-title mb-0">Add, Edit & Remove</h4>
                                </CardHeader>

                                <CardBody>
                                    <div id="customerList">
                                        <Row className="g-4 mb-3">
                                            <Col className="col-sm-auto">
                                                <div className="d-flex gap-1">
                                                <Button color="success" onClick={handleNavigationForm} className="float-end"><i className="ri-add-line align-bottom me-1"></i>Advance Form</Button>
                                                    
                                                </div>
                                            </Col>
                                            <Col className="col-sm">
                                                <div className="d-flex justify-content-sm-end">
                                                    <div className="search-box ms-2">
                                                        <input type="text" className="form-control search" placeholder="Search..."
                                                        
                                                         />
                                                        <i className="ri-search-line search-icon"></i>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <div className="table-responsive table-card mt-3 mb-1">
                                            <table className="table align-middle table-nowrap" id="employeeTable">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th className="sort" data-sort="employee_id">ID</th>
                                                        <th className="sort" data-sort="txdate">Transaction Date</th>
                                                        <th className="sort" data-sort="verified by">Verified By</th>
                                                        <th className="sort" data-sort="amt">Total Amount</th>
                                                        <th className="sort" data-sort="remarks">Remarks</th>
                                                        <th className="sort" data-sort="action">Action</th>
                                                    </tr>
                                                </thead>

                                               
                                                <tbody className="list form-check-all">
                                             {MyDatalist.map((item) => (
                                             <tr key={item.id}>
                                            <td className="employee_id">{item.id}</td>
                                            <td className="txdate">{item.transaction_Date}</td>
                                            <td className="verified by">{item.verified_By}</td>
                                            <td className="amt">{item.total_Amt}</td>
                                            <td className="remarks">{item.remarks}</td>
                                            <td className="action">
                                         <ButtonGroup>
                                        <div className=" d-flex gap-1 ">
                                         
                                        <Button 
                                        color="btn btn-soft-success"
                                        className="  btn-sm gap-1 "
>                                       <Link to={`/advance-form/details/${item.id}`} state={{ item}}>
                                       <i className="bx bx-show" />
                                      </Link>
                                      </Button>
                                      <Button color="btn btn-soft-warning"
                                      className=" btn-sm gap-1 "
                                        >
                                      <Link to={`/advance-form/edit/${item.id}`} state={{ item }}>
                                      <i className="ri-edit-line"></i>
                                     </Link>
                                       </Button>
                                       <Button className="btn btn-soft-danger btn-sm gap-1"
                                                    // onClick="deleteMultiple()"
                                              color="danger"
                                             
                                            onClick={() => handleDelete(item.id)}
                                                  >
                                                    <i className="ri-delete-bin-2-line"></i></Button>
                                    </div>
                                     </ButtonGroup>
                                             </td>
                                               </tr>
                                            ))}
                                            </tbody>            
                                            </table>
                                            <div className="noresult" style={{ display: "none" }}>
                                                <div className="text-center">
                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                                                        colors="primary:#121331,secondary:#08a88a" style={{ width: "75px", height: "75px" }}>
                                                    </lord-icon>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                    <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any
                                                        orders for you search.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <div className="pagination-wrap hstack gap-2">
                                                <Link className="page-item pagination-prev disabled" to="#">
                                                    Previous
                                                </Link>
                                                <ul className="pagination listjs-pagination mb-0"></ul>
                                                <Link className="page-item pagination-next" to="#">
                                                    Next
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    </Container>
                    </div>
     
    </React.Fragment>
  );
}

export default AdvanceList;






